import React from 'react';
import PropTypes from 'prop-types';
import { BOOKING_BASE_URL } from '../../../utils/constants';
import { inject } from 'mobx-react';
import { withI18n } from 'spa/Components/Context';
import {withRouter, locationShape} from 'react-router';

import DocumentMeta from 'spa/Components/DocumentMeta';
import DocumentTitle from 'spa/Components/DocumentTitle';
import Form from 'spa/Components/Form/Form';
import FormHandler from 'spa/Components/Form/FormHandler';

import { IconSizes } from '@urbanmassage/component-library/lib/Theme/b2c-theme';
import Button, { ButtonThemeTypes } from '@urbanmassage/component-library/lib/Button/Button';
import CheckmarkRounded from '@urbanmassage/component-library/lib/Icons/CheckmarkRounded/CheckmarkRounded';
import Input, { InputType } from '@urbanmassage/component-library/lib/Input/Input';
import Typography, { TypeVariants } from '@urbanmassage/component-library/lib/Typography/Typography';

import GiftsNavigation from './GiftsNavigation';
import GiftsRedeemSession from './GiftsRedeemSession';


import './gifts-redeem.less';

const GiftCardRedeem = ({
  location,
  notifications,
  redeemReferral,
  session,
  tracker,
}, { i18n }) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [voucherCode, setVoucherCode] = React.useState('');
  const [successRedeem, setSuccessRedeem] = React.useState(false);

  const handleEnterCode = (e) => {
    setVoucherCode(e.target.value);
  };

  const redeemCode = (promoCode) => {
    setIsLoading(true);
    redeemReferral.load({ voucher: promoCode }).then((response) => {
      tracker.track('Successfully redeemed voucher/referral code', {
        category: 'Redeem gift voucher',
        label: session.user && session.user.id,
        data: {
          user_id: session.user && session.user.id,
          promoCode,
        },
      });

      setVoucherCode('');
      setIsLoading(false);
      setSuccessRedeem(true);
    }, (error) => {
      setIsLoading(false);
      setVoucherCode('');
      tracker.track('Error on redeem voucher/referral code', {
        category: 'Redeem gift voucher',
        label: session.user && session.user.id,
        data: {
          user_id: session.user && session.user.id,
          promoCode,
        },
      });

      const redeemReferralError =
        redeemReferral.error &&
        redeemReferral.error.json;

      if (redeemReferralError) {
        if (redeemReferralError.type) {
          redeemReferralError.code = redeemReferralError.type;
        }

        notifications.add({
          id: 'error-redeeem-voucher',
          type: 'error',
          title: i18n.__error(redeemReferralError),
        });
      }
    });
  };

  const onReceiveForm = (state) => {
    const { promoCode } = state.body;

    redeemCode(promoCode);
  };

  const sessionSuccess = (code) => {
    redeemCode(code);
  };


  return (
    <div>
      <DocumentTitle title={i18n._x('Redeem Massage Gift Vouchers', 'Redeem Gift page meta title')} />
      <DocumentMeta
        title={i18n._x('Redeem Massage Gift Vouchers - Urban', 'Redeem Gift page meta title')}
        description={i18n._x('Redeem your Urban gift voucher here and a massage therapist could be with you in an hour!', 'Gifts page Meta Description')}
      />
      <div className="gifts-redeem__wrapper">
        <div className="gifts-redeem__navigation">
          <GiftsNavigation currentStep={4} />
        </div>
        <div className="gifts-redeem__login-form-wrapper">
          {!session.user && (
            <GiftsRedeemSession
              onSessionSuccess={sessionSuccess} />
          )}
        </div>
        <div className="gifts-redeem__form-wrapper">
          {session.user && successRedeem && (
            <div>
              <div className="gifts-redeem__form-graphic" />
              <div className="gifts-redeem__success-icon-wrapper">
                <CheckmarkRounded color="green" size={IconSizes.large} className="gifts-confirm__info-icon" />
              </div>
              <Typography variant="h1" className="gifts-redeem__title" align="center">
                {i18n._x('Redeem your gift', 'Gifts page')}
              </Typography>
              <Typography variant={TypeVariants.bodyXLarge} className="gifts-redeem__success-text" align="center">
                {i18n._x('Your voucher has been redeemed and the credit was applied to your account!', 'Gifts page')}
              </Typography>
              <Button
                block
                href={`/${i18n.lc}/${BOOKING_BASE_URL}`}
                theme={ButtonThemeTypes.primary}
              >
                {i18n._x('Book now', 'Gifts page')}
              </Button>
            </div>
          )}
          {session.user && !successRedeem && (
            <div>
              <div className="gifts-redeem__form-graphic" />
              <Typography variant="h1" className="gifts-redeem__title" align="center">
                {i18n._x('Redeem your gift', 'Gifts page')}
              </Typography>
              <FormHandler method="POST" onReceiveForm={onReceiveForm}>
                <Form
                  to={location}
                  method="POST"
                  disabled={isLoading}
                  className="form"
                >
                  <Input
                    type={InputType.text}
                    name="promoCode"
                    required
                    label={i18n._x('Voucher code', 'Gifts page form')}
                    placeholder={i18n._x('Enter code', 'Gifts page form')}
                    onChange={handleEnterCode}
                    value={voucherCode}
                    className="gifts-redeem__input"
                  />
                  <Button
                    block
                    disabled={isLoading}
                    type="submit">
                    {i18n._x('Redeem', 'Gift redeem')}
                  </Button>
                </Form>
              </FormHandler>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

GiftCardRedeem.propTypes = {
  location: locationShape.isRequired,
  redeemReferral: PropTypes.object.isRequired,
  session: PropTypes.object.isRequired,
  tracker: PropTypes.shape({
    track: PropTypes.func.isRequired,
  }),
  notifications: PropTypes.object.isRequired,
};

export default inject(({
  store: {
    redeemReferral,
    session,
    tracker,
    notifications,
  },
}) => ({
  redeemReferral,
  session,
  tracker,
  notifications,
}))(withRouter(withI18n(GiftCardRedeem)));



// WEBPACK FOOTER //
// ./spa/Pages/Gifts/GiftCardRedeem.jsx